import React from 'react'

import { VendorSearchState } from '../../states/useVendorSearchState'
import SupplierCard from '../supplier-card/supplier-card'
import { useSupplierCard } from '../supplier-card/useSupplierCard'

type SupplierCardItemProps = {
  vendor: VendorSearchState['vendors'][number]
  enableFavourite: boolean
}

const SupplierCardItem: React.FC<SupplierCardItemProps> = ({ vendor, enableFavourite }) => {
  const cardData = useSupplierCard({ vendor, enableFavourite })

  return (
    <SupplierCard
      companyName={cardData.companyName}
      description={cardData.description}
      logo={cardData.logo}
      image={cardData.image}
      rating={cardData.rating}
      totalRatings={cardData.totalRatings}
      showRating={cardData.showRating}
      favorite={cardData.favorite}
      vendor={cardData.vendor}
      deliverySummary={cardData.deliverySummary}
      privateItem={cardData.privateItem}
      approvedVendor={cardData.approvedVendor}
      tags={cardData.tags}
      itemSearchMetadata={vendor.itemSearchMetadata}
    />
  )
}

export default SupplierCardItem
export { SupplierCardItem }
